import React, { Component } from "react";

import step2 from "../images/guidelines/step2.jpg";
import step5 from "../images/guidelines/step5.jpg";
import step7 from "../images/guidelines/step7.jpg";
import step8 from "../images/guidelines/step8.jpg";
import step9 from "../images/guidelines/step9.jpg";
import step10 from "../images/guidelines/step10.jpg";
import step11 from "../images/guidelines/step11.jpg";
import step12 from "../images/guidelines/step12.jpg";
import step13 from "../images/guidelines/step13.jpg";


class Guidelines extends Component {
    render() {
        return (
            <div className="template-flex">
                <div className="skill-home scrollable">
                    <div className="tp-title">
                        <h3>Supervity Guidelines</h3>
                    </div>
                    <div className="doc-text">
                        <p>The following guidelines will give you best leverage of Supervity application.</p>
                        <ol type="number">
                            <li>
                                <p>Use Desktops/Laptops/Virtual Machines (VMs) with the below minimal configuration for better experience with Supervity.</p>
                                <ul>
                                    <li>OS: Windows 10 or 11, Windows Server Machine 2016 or above</li>
                                    <li>RAM: 8 GB or above</li>
                                    <li>Disk: 100 GB or above</li>
                                    <li>Browser: Google Chrome or Microsoft Edge</li>                                    
                                </ul>
                            </li>
                            <li>
                                <p>Wait till the webpage loads fully before capturing the steps (web clicks, data entry into input boxes, value selection from dropdown boxes etc) during ‘show process/recording process’. This will ensure smooth recording.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step2} />
                            <li>
                                <p>Always capture steps on web applications as if you are navigating the application first time. In other words, do not capture steps from the 'Recently visited' or 'Customized view' screens during skill creation.</p>                                
                            </li>
                            <li>
                                <p>Do not capture steps which include login credentials while creating ‘In-App Walkthrough’ skills to ensure security and privacy.</p>
                            </li>
                            <li>
                                <p>While creating ‘In-App Walkthrough’ skills, Supervity marks all 'Data typing into input box' and 'Value selection from drop down box' steps as manual steps and selects 'Yes' for 'Display Next Button?' option by default. Ensure all 'Data typing into input box' and 'Value selection from drop down box' steps as manual steps and select 'Yes' for 'Display Next Button?' option.</p>
                                <div className="doc-img"></div>
                                <p>calendar’ steps, select 'Yes' for 'Display Next Button?' option.</p>
                            </li>
                            <img src={step5} />
                            <li>
                                <p>Remove all the data submission steps such as 'Data typing into input box', 'Value selection from drop down box', ‘selecting a checkbox or a radio button’, ‘selecting a date from a calendar’ steps while creating ‘In-App Walkthrough’ skills as these steps holds the creator’s data.</p>
                            </li>
                            <li>
                                <p>Modify/update default tooltip messages captured by Supervity for every step as required while creating ‘User Documentation/In-App Walkthrough’ skills.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step7} />
                            <li>
                                <p>Adjust the position of instruction widget as required before publishing the ‘In-App Walkthrough’ skills.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step8} />
                            <li>
                                <p>Mask/blur the sensitive information (if any) visible in the screenshot of each step by using the mask feature (Click Pencil symbol available at top right corner of every step)</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step9} />
                            <li>
                                <p>Use 'Show' option under ‘+’ menu to capture additional steps in between. Make sure to remove 'Open web page' step if you capture steps on web page using ‘+’ menu to avoid repetition.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step10} />
                            <li>
                                <p>Select the right option for 'Prompt user for the application URL during skill onboarding?' while publishing In-App Walkthrough skills. If the application is a SaaS application and the base URL is common for all users, then select 'No'. Otherwise select 'Yes'</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step11} />
                            <li>
                                <p>Enter data into searchable dropdown boxes of web pages and select the required value from the search result by clicking on it or by hitting enter rather than directly clicking the required value from the dropdown while creating Automation skills. This approach helps to parameterize the data selection from drop down during automation.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step12} />
                            <li>
                                <p>Enter date in the required format into the date fields on web pages rather than selecting the date from the calendar. This approach helps to parameterize the date selection from drop down during automation.</p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step13} />
                            <li>
                                <p>In the current version, use browser extension in case of web-based ‘User Documentation/In-App Walkthrough’ skills.</p>
                            </li>
                            <li>
                                <p>When creating 'Import data from spreadsheet to webapp' skill, make sure to have column headings as the first row in the spreadsheet that is being uploaded.</p>
                            </li>
                            <li>
                                <p>Ensure at least one row of data is present in the spreadsheet that is being uploaded to 'Import data from spreadsheet to webapp' skills.</p>
                            </li>
                            <li>
                                <p>Do not upload/provide password protected spreadsheets to Supervity while creating ‘Import data from spreadsheet to webapp/Automation’ skills.</p>
                            </li>
                            <li>
                                <p>As a security best practice, store all your passwords in secret vault while creating automation skills.</p>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        );
    };
}

export default Guidelines;